import React from "react";
import { Navigate } from "react-router-dom";
import VisualSearch from "../components/VisualSearch";
import { ScanSearch } from "lucide-react";
import { BUSINESS } from "../constants/business";
import { useCustomerAuth } from "../context/CustomerAuthContext";
import { Loader2 } from "lucide-react";

const HomePage = () => {
  const { customer, loading } = useCustomerAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="w-7 h-7 animate-spin text-brand" />
      </div>
    );
  }

  if (!customer) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="min-h-screen flex flex-col">
      <div className="max-w-7xl mx-auto w-full px-4 sm:px-8 py-8 sm:py-10 flex-1">
        <div className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-brand font-semibold mb-6">
          <ScanSearch className="w-4 h-4" /> {BUSINESS.dataset_tagline}
        </div>
        <VisualSearch />
      </div>

      {/* Compact SaaS footer */}
      <footer className="border-t bg-foreground text-background mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 py-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div>
            <div className="font-heading font-black text-lg">{BUSINESS.product}</div>
            <p className="text-sm text-background/70 mt-1">AI-powered visual spare parts search.</p>
          </div>
          <div className="text-sm text-background/70">
            Need help? <a href={`mailto:${BUSINESS.support_email}`} className="text-background hover:underline">{BUSINESS.support_email}</a>
          </div>
        </div>
        <div className="border-t border-background/15">
          <div className="max-w-7xl mx-auto px-4 sm:px-8 py-3 text-xs text-background/50">
            © {new Date().getFullYear()} {BUSINESS.product}. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;
